import React from "react";
import { CheckCircleTwoTone, CloseCircleTwoTone, ExclamationCircleTwoTone, InfoCircleTwoTone } from "@ant-design/icons";

export const SexOffenderIcon = ({ type }) => {
  let title = type || "";
  if (title === "ReviewNeeded") {
    title = "Need Review";
  } else if (title === "Fail") {
    title = "Is sex offender";
  }

  return (
    <div style={{ fontSize: 24 }} title={title}>
      {type === "Pass" && <CheckCircleTwoTone twoToneColor="#52c41a" />}
      {type === "Fail" && <CloseCircleTwoTone twoToneColor="#eb2f96" />}
      {type === "ReviewNeeded" && <ExclamationCircleTwoTone twoToneColor="#efef37" />}
      {type === "Unknown" && <InfoCircleTwoTone />}
    </div>
  );
};
